import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { LoginForm } from '../components/LoginForm';
import { Logo } from '../../../components/Logo';
import '../styles/LoginPage.css';

export const LoginPage: React.FC = () => {
  const { isLoading, error, login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (credentials: {
    email: string;
    password: string;
  }) => {
    try {
      const result = await login(credentials.email, credentials.password);

      // Don't redirect if user needs to change password
      if (result?.user?.needsPasswordChange) {
        console.log('User needs password change, staying on current page');
        return;
      }

      // Redirect based on user role
      const userRole = result?.user?.role;
      if (userRole === 'admin') {
        navigate('/user-management');
      } else if (userRole === 'manufacturer') {
        navigate('/product-management');
      } else if (userRole === 'practitioner') {
        navigate('/dashboard');
      } else if (userRole === 'insurance') {
        navigate('/insurance');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      // Error is handled by Redux
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="login-page">
      {/* Background Container */}
      <div className="background-container">
        {/* Top Section - Logo */}
        <div className="top-section" style={{ marginTop: '-10px' }}>
          <Logo size="xl" variant="dark" />
        </div>

        {/* Bottom Section - Main Content - COMMENTED OUT */}
        {/* <div className="bottom-section">
          <div className="info-section">
            <div className="hero-content">
              <h1 className="hero-title headline-1">
                Advanced Wound Care
                <span className="title-accent">Management Platform</span>
              </h1>
              <p className="hero-description body-1">
                Seamlessly connecting medical product manufacturers with healthcare practices for comprehensive wound care management and superior patient outcomes.
              </p>

              <div className="feature-highlights">
                <div className="feature-item" style={{ '--animation-order': '1' } as React.CSSProperties}>
                  <div className="feature-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                      <path d="M22 21V19C22 18.1645 21.7155 17.3541 21.2094 16.7071C20.7033 16.0601 19.9999 15.6214 19.25 15.47" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45768C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="feature-content">
                    <h3 className="subtitle-2">Multi-Role Access</h3>
                    <p className="body-2">Manufacturers & Practices</p>
                  </div>
                </div>

                <div className="feature-item" style={{ '--animation-order': '2' } as React.CSSProperties}>
                  <div className="feature-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"/>
                      <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="feature-content">
                    <h3 className="subtitle-2">Secure Platform</h3>
                    <p className="body-2">HIPAA Compliant</p>
                  </div>
                </div>

                <div className="feature-item" style={{ '--animation-order': '3' } as React.CSSProperties}>
                  <div className="feature-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 12L4 10L6 12L8 8L10 12L12 6L14 12L16 8L18 12L20 10L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="feature-content">
                    <h3 className="subtitle-2">Real-Time Data</h3>
                    <p className="body-2">Live Insights</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="login-section">
            <div className="login-card">
              <div className="login-header">
                <h2 className="headline-3">Welcome Back</h2>
                <p className="body-1">Sign in to your wound care management platform</p>
              </div>

              {error && (
                <div className="login-error">
                  <div className="error-icon">⚠️</div>
                  <span>{error}</span>
                </div>
              )}

              <LoginForm onSubmit={handleLogin} isLoading={isLoading} />
            </div>
          </div>
        </div> */}

        {/* Centered Login Form */}
        <div className="centered-login">
          <div className="login-card" style={{ marginTop: '-85px' }}>
            <div className="login-header">
              <h2
                className="headline-3"
                style={{ color: '#002e6d', fontSize: '15px' }}
              >
                Welcome!
              </h2>
              <p className="body-1" style={{ fontSize: '15px' }}>
                Sign in to your MPM Medical Wound Care Management Platform
              </p>
            </div>

            {error && (
              <div className="login-error">
                <div className="error-icon">⚠️</div>
                <span>{error}</span>
              </div>
            )}

            <LoginForm onSubmit={handleLogin} isLoading={isLoading} />
          </div>
        </div>

        {/* Bottom-Left Overlay Text */}
        <div className="overlay-text">
          <h1
            className="overlay-line-1"
            style={{ fontSize: '48px !important' }}
          >
            Streamlining Care for
          </h1>
          <h1
            className="overlay-line-2"
            style={{ fontSize: '48px !important' }}
          >
            Superior Outcomes
          </h1>
        </div>
      </div>
    </div>
  );
};
